import create from 'zustand';
import { BasketClientStore } from '../models/basketModel';

export const useBasketState = create<BasketClientStore>((set) => ({
	setLastAddedItem: (lastAddedItem) => set({ lastAddedItem, error: undefined }),
	onErrorAddingItem: (error, variation) => set({ lastAddedItem: variation, error }),
}));
